<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Program Renja</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Tahun</span>
                                <select class="form-control" v-model="form.tahun" @change="getSetupRenstra()">
                                    <option value="" selected> -- Semua Tahun --</option> 
                                    <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Jenis Renja</span>
                                <select class="form-control" v-model="form.renja_setup_id"  @change="getBidangFilter()">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_renja_setup" :key="data.renja_setup_id" :value="data.renja_setup_id">{{data.renja_jenis}}</option>
                                </select>
                            </div>

                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-12">
                                <span class="huruf_input">Bidang Urusan Pemerintahan</span>
                                <select class="form-control" v-model="form.bidang_urusan_pemerintahan_id" @change="getData()">
                                    <option value="" selected> -- Pilih Bidang Urusan --</option> 
                                    <option v-for="data in list_bidang_filter" :key="data.bidang_urusan_pemerintahan_id" :value="data.bidang_urusan_pemerintahan_id">[{{data.kode_bidang}}]. {{data.nama_bidang}}</option>
                                </select>
                            </div>
                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">

                                    <th class="tabel_center text-center" style="width: 7%">Kode </th>
                                    <th class="tabel_center text-center" style="width: 30%">Nama Program</th>
                                    <th class="tabel_center text-center" style="width: 8%">Target <br> Anggaran Renstra</th>
                                    <th class="tabel_center text-center" style="width: 8%">Realisasi Anggaran s/d <br> Tahun {{parseInteger(form.tahun)-1}}</th>
                                    <th class="tabel_center text-center" style="width: 8%">Pagu Indikatif <br> (Tahun {{parseInteger(form.tahun)}})</th>
                                    <th class="tabel_center text-center" style="width: 8%">Jumlah Anggaran <br> Kegiatan</th>
                                    <th class="tabel_center text-center" style="width: 8%">Prakiraan Maju <br> (Tahun {{parseInteger(form.tahun)+1}})</th>
                                    <th class="tabel_center text-center" style="width: 8%">Jumlah <br> Kegiatan</th>
                                    <th class="tabel_center text-center" style="width: 15%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center">
                                    <tr class="h_isitable"  v-for="data in list_data" :key="data.renja_program_id">
                                        <td class="tabel_center text-center" >
                                            <div v-if="!cek_error_sync(data.cek_program_rkpd, data.cek_program_pembangunan)">
                                                <a @click="selectDataSync(data)" href="javascript:void(0);" title="Tidak Terkoneksi dengan Program RKPD" data-toggle="modal" data-target="#m_konektifitas_data">
                                                    <i class="material-icons" style="color:#e04747">report</i>
                                                </a>
                                            </div>
                                            <div v-if="cek_error_sync(data.cek_program_rkpd, data.cek_program_pembangunan)">
                                                {{data.program_kode}}
                                            </div>
                                            
                                        </td>
                                        <td class="tabel_center">{{data.program_nama}}</td>
                                        <td class="tabel_center text-right" >{{getAnggaranRenstra(data)}}</td>
                                        <td class="tabel_center text-right" >{{format_uang(data.realisasi_thn_lalu)}}</td>
                                        <td class="tabel_center text-right" >{{format_uang(data.pagu_indikatif_thn_ini)}}</td>
                                        <td class="tabel_center text-center" >{{0}}</td>
                                        <td class="tabel_center text-right" >{{format_uang(data.perkiraan_thn_depan)}}</td>
                                        <td class="tabel_center text-center" >{{data.jml_kegiatan}}</td>
                                        <td class="tabel_center text-center" >

                                            <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect" title="Tambah Indikator Hasil Program" id="edit_data" data-toggle="modal" data-target="#m_list_data_indikator">
                                                <i class="material-icons" >control_point</i>
                                            </button>
                                            &nbsp;
                                            <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Atur Nilai Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                                <i class="material-icons" >settings</i>
                                            </button>
                                            &nbsp;
                                            <button @click="removeData(data.renja_program_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                <i class="material-icons" >clear</i>
                                            </button>

                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <!-- <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div> -->
                        <hr>
                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH JENIS RENJA TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">
                                                <!-- 
                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Urusan</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select v-model="form.urusan_pemerintahan_id" class="form-control">
                                                                        <option  v-for="data in list_urusan" :key="data.urusan_pemerintahan_id" :value="data.urusan_pemerintahan_id">{{data.nama_urusan}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->


                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Bidang Urusan</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select v-model="form.bidang_urusan_pemerintahan_id" class="form-control" @change="getProgram()">
                                                                        <option  v-for="data in list_bidang" :key="data.bidang_urusan_pemerintahan_id" :value="data.bidang_urusan_pemerintahan_id">{{data.nama_bidang}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="table-responsive">
                                                        <table class="table table-bordered" style="width: 100%">
                                                            <thead>
                                                            <tr class="bg-success kepala_table_f tabel_center">

                                                                <th class="text-center" style="width: 10%">Kode</th>
                                                                <th class="text-center" style="width: 20%">Program</th>
                                                                <th class="text-center" style="width: 10%">Anggaran Renstra</th>
                                                                <th class="text-center" style="width: 15%">#</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody class="tabel_center" >
                                                            <tr class="h_isitable" v-for="data in list_program" :key="data.rkpd_program_id">
                                                                <td class="tabel_center text-center" >{{data.program_kode}}</td>
                                                                <td class="tabel_center" >{{data.program_nama}}</td>
                                                                <td class="tabel_center text-right" >{{getAnggaranRenstra(data)}}</td>
                                                                <td class="tabel_center text-center" >
                                                                    <input v-model="form.rkpd_program_id" type="checkbox" :value="{rkpd_program_id : data.rkpd_program_id, program_id : data.program_id, program_pembangunan_id: data.program_pembangunan_id}" :id="data.rkpd_program_id" class="filled-in chk-col-blue" :checked="1">
                                                                    <label :for="data.rkpd_program_id"></label>
                                                                </td>
                                                            </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>

                                                                                                   

                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Realisasi Anggaran s/d Tahun {{parseInteger(form.tahun)-1}}</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input type="number" class="form-control" v-model="form.realisasi_thn_lalu">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Pagu Indikatif <br> (Tahun {{parseInteger(form.tahun)}})</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input type="number" class="form-control" v-model="form.pagu_indikatif_thn_ini">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Prakiraan Maju <br> (Tahun {{parseInteger(form.tahun)+1}})</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input type="number" class="form-control" v-model="form.perkiraan_thn_depan">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETTING xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_indikator_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH INDIKATOR</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">RRealisasi Anggaran s/d Tahun {{parseInteger(form.tahun)-1}}</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input type="number" class="form-control" v-model="form.realisasi_thn_lalu">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Pagu Indikatif <br> (Tahun {{parseInteger(form.tahun)}})</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input type="number" class="form-control" v-model="form.pagu_indikatif_thn_ini">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Prakiraan Maju <br> (Tahun {{parseInteger(form.tahun)+1}})</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input type="number" class="form-control" v-model="form.perkiraan_thn_depan">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETTING xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_list_data_indikator" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-xlg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                            <div class="modal-body">
                                                <button @click="getRenstraProgramIndikator()" class="btn btn-info" data-toggle="modal" data-target="#m_tambah_data_indikator_kinerja">Tambah Sasaran/Indikator</button>
                                                <!-- &nbsp;
                                                <button class="btn btn-info" data-toggle="modal" data-target="#m_tambah_data_indikator_kinerja">Tambah Indikator</button> -->
                                                <hr>
                                                <b>SASARAN</b>
                                                <div class="table-responsive">
                                                    <table class="table-bordered" width="100%">
                                                        <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center">
                                                                <th class="tabel_center text-center" style="width:5%">No</th>
                                                                <th class="tabel_center text-center" style="width:85%">Uraian Sasaran</th>
                                                                <th class="tabel_center text-center" style="width:10%"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr class="h_isitablex" v-for="data in list_sasaran" :key="data.renja_program_sasaran_id">
                                                                <td class="tabel_center text-center">{{data.no}}</td>
                                                                <td class="tabel_center" >{{data.uraian}}</td>
                                                                <td class="tabel_center text-center">
                                                                    <button class="btn bg-orange btn-xs waves-effect"  @click="selectSasaran(data)" data-toggle="modal" data-target="#m_edit_sasaran">
                                                                        <i class="material-icons" >create</i>
                                                                    </button>
                                                                    &nbsp;
                                                                    <button class="btn bg-red btn-xs waves-effect"  @click="removeSasaran(data)">
                                                                        <i class="material-icons" >close</i>
                                                                    </button>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>

                                                <hr>
                                                <b>INDIKATOR</b>
                                                <div class="table-responsive">
                                                    <table class="table-bordered" width="100%">
                                                        <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center">
                                                                <th class="tabel_center text-center" style="width:5%">No</th>
                                                                <th class="tabel_center text-center" style="width:65%">Uraian Indikator</th>
                                                                <th class="tabel_center text-center" style="width:5%">Satuan</th>
                                                                <th class="tabel_center text-center" style="width:10%">Target Renstra</th>
                                                                <th class="tabel_center text-center" style="width:10%">Target Renja</th>
                                                                <th class="tabel_center text-center" style="width:5%"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr class="h_isitablex" v-for="data in list_indikator" :key="data.renja_program_indikator_id">
                                                                <td class="tabel_center text-center">{{data.no_indikator}}</td>
                                                                <td class="tabel_center" >{{data.uraian}}</td>
                                                                <td class="tabel_center text-center">{{data.satuan}}</td>
                                                                <td class="tabel_center text-center">{{getRenstraThnIndikator(data)}}</td>
                                                                <td class="tabel_center text-center">{{data.target}}</td>
                                                                <td class="tabel_center text-center">
                                                                    <button class="btn bg-orange btn-xs waves-effect"  @click="selectIndikator(data)" data-toggle="modal" data-target="#m_edit_indikator">
                                                                        <i class="material-icons" >create</i>
                                                                    </button>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                   
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_tambah_data_indikator_kinerja" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">INDIKATOR SASARAN KEGIATAN</h4>
                                        </div>
                                    <form @submit.prevent="addindikatorSasaran()">
                                        <div class="modal-body">
                                            <div v-if="!cek_indikator_array" class="text-center" style="font-weight:bold">
                                                <img width="150px" src="images/lol.jpg" alt="">
                                                <br>
                                                <span style="color:#8c8c8c">Pasti Kita belum isi indikatornya ini Program di Renstra-ta toh..??</span> <br>
                                                <span>Kita isimi dulu </span> <a @click="routerTO('/planing_renstra_program')" href="javascript:void(0);" style="color:#99cc00" >DI SINI</a> <br>
                                                <br>
                                                <span>Terus kita carimi ini program :</span>
                                                <h3 style="color:#808080">" {{Sync.program_nama}} "</h3>
                                                <span>Terus Kita click Button seperti ini -> <img width="30px" src="images/btn_indikator.JPG" alt=""> dan kita isimi indikatornya</span> <br>
                                                <span>Karena ndk bisa kita lanjut klo belum kita input indikator renstra-ta</span>

                                            </div>

                                            <div v-if="cek_indikator_array">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="sasaran.no" type="text" class="form-control" placeholder="Ex : 1">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="sasaran.uraian" type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <hr>
                                                INDIKATOR SASARAN
                                                <hr>

                                                <table class="table-bordered">
                                                    <thead>
                                                        <tr class="bg-info kepala_table_f tabel_center">
                                                            <th class="tabel_center text-center" style="width:5%">No</th>
                                                            <th class="tabel_center text-center" style="width:50%">Uraian</th>
                                                            <th class="tabel_center text-center" style="width:5%">Satuan</th>
                                                            <th class="tabel_center text-center" style="width:20%">Target Renstra</th>
                                                            <th class="tabel_center text-center" style="width:20%">Target Renja</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr class="h_isitablex" v-for="data in sasaran.indikator" :key="data.indikator_id">
                                                            <td class="tabel_center text-center">{{data.no_indikator}}</td>
                                                            <td class="tabel_center" >{{data.uraian}}</td>
                                                            <td class="tabel_center text-center">{{data.satuan}}</td>
                                                            <td class="tabel_center text-center">{{getRenstraThnIndikator(data)}}</td>
                                                            <td class="tabel_center text-center">
                                                                <input type="number" style="width : 100%"  step="any" v-model="data.indikator">
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>



                                            </div>


                                      
                                        </div>
                                        <div class="modal-footer">
                                            <button  v-if="cek_indikator_array" type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                            <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_edit_sasaran" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT SASARAN</h4>
                                        </div>
                                    <form @submit.prevent="editSasaran()">
                                        <div class="modal-body">

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No Sasaran</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="sasaran.no" type="text" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Sasaran</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="sasaran.uraian" type="text" class="form-control">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        </div>
                                        <div class="modal-footer">
                                            <button type="submit" class="btn bg-orange waves-effect" >EDIT</button>
                                            <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_edit_indikator" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT INDIKATOR</h4>
                                        </div>
                                    <form @submit.prevent="editIndikator()">
                                        <div class="modal-body">

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.target" type="text" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        </div>
                                        <div class="modal-footer">
                                            <button type="submit" class="btn bg-orange waves-effect" >EDIT</button>
                                            <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA SYNC xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_konektifitas_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <span style="font-size:120%">ATUR RELASI PROGRAM (RKPD)</span> <br>
                                            <i><span style="font-size:80%">[{{Sync.program_kode}}]. {{Sync.program_nama}}</span></i>
                                            
                                        </div>
                                        <form @submit.prevent="editDataSync()">
                                            <div class="modal-body">

                                                <div class="row clearfix">
                                                    <div class="col-md-3 form-control-label">
                                                        <label for="kode">Program Pembangunan (RKPD)</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <select class="form-control" v-model="Sync.rkpd_program" @change="selectDataSyncProgram()">
                                                                <option v-for="data in list_program_sync" :key="data.program_pembangunan_id" :value="data">[{{data.program_kode}}]. {{data.program_nama}}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-warning waves-effect">SINKRONISASI</button>
                                                <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA SYNC xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                    <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_renja_program/';




    const ADD_URL_SETUP_RENSTRA = URL_APP+'api/v1/planning_renja_setup/';
    const ADD_URL_URUSAN = URL_APP+'api/v1/planning_urusan/';
    const ADD_URL_BIDANG = URL_APP+'api/v1/planning_bidang/';
    const ADD_URL_PROGRAM = URL_APP+'api/v1/planning_rkpd_program/';

    const ADD_URL_RENSTRA_PROGRAM = URL_APP+'api/v1/planning_renstra_program/';

    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';
    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'
    


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                form : {
                    renja_program_id  : '',
                    urusan_pemerintahan_id : '',
                    bidang_urusan_pemerintahan_id : '',
                    program_pembangunan_id : '',
                    rkpd_program_id : [],
                    program_id : '',
                    pagu_indikatif_thn_ini : 0,
                    realisasi_thn_lalu : 0,
                    perkiraan_thn_depan : 0,


                    renja_setup_id : '',
                    tahun : '',
                    unit_kerja : '',
                    instansi_id : '',
                    
                },
                indikator : {
                    renja_program_indikator_id : '',
                    no_indikator : 0,
                    target : 0,
                },
                cek_indikator_array : false,

                sasaran : {
                    renja_program_sasaran_id : '',
                    no : '',
                    uraian : '',
                    indikator : [],
                },

                Sync : {
                    rkpd_program : '',
                    renja_program_id : '',
                    program_pembangunan_id : '',
                    program_nama : '',
                    program_kode : '',
                },

                unit_kerja : '',
                unit_kerja_full : '',
                instansi_id : '',


                list_renja_setup :[],
                list_urusan :[],
                list_bidang_filter :[],
                list_bidang :[],
                list_program :[],
                list_sasaran : [],
                list_indikator : [],

                list_program_sync :[],

                check_data_add : false,
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                list_tahun : [],

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;
            this.instansi_id = get_profile.profile.instansi_id;

            this.form.unit_kerja = get_profile.profile.unit_kerja;
            this.form.instansi_id = get_profile.profile.instansi_id;

            this.getDataTahun();
            // this.getData();
            // this.getSetupRenstra();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.form)


                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
                // console.log(this.form.rkpd_program_id);
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      unit_kerja : this.unit_kerja,
                      renja_setup_id : this.form.renja_setup_id,
                      tahun : this.form.tahun,
                      bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data;
                //   this.page_last = res_data.jml_data;
                //   console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                console.log(data);
                this.form = data;
                this.form = {
                    renja_program_id  : data.renja_program_id,
                    urusan_pemerintahan_id : data.urusan_pemerintahan_id,
                    bidang_urusan_pemerintahan_id : data.bidang_urusan_pemerintahan_id,
                    program_pembangunan_id : data.program_pembangunan_id,
                    program_id : data.program_id,
                    pagu_indikatif_thn_ini : data.pagu_indikatif_thn_ini,
                    realisasi_thn_lalu : data.realisasi_thn_lalu,
                    perkiraan_thn_depan : data.perkiraan_thn_depan,


                    renja_setup_id : data.renja_setup_id,
                    tahun : data.tahun,
                    unit_kerja : data.unit_kerja,
                    instansi_id : data.instansi_id,
                };

                this.Sync.program_nama = data.program_nama;

                // this.getRenstraProgramIndikator();

                // console.log(this.form);
                // this.getDataTahun();
                this.getSasaran();
                this.getIndikator();
            },
            
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                // this.list_urusan = [];
                // this.list_bidang = [];
                this.list_program = [];
                this.form. rkpd_program_id = [];
            },
            selectDataSync : function(data){
                console.log(data)

                this.Sync = {
                    rkpd_program_id : data.rkpd_program_id,
                    renja_program_id : data.renja_program_id,
                    program_pembangunan_id : data.program_pembangunan_id,
                    program_nama : data.program_nama,
                    program_kode : data.program_kode
                },
 

                this.getProgramSync();
            },
            selectDataSyncProgram : function(){
                console.log(this.Sync.rkpd_program.program_pembangunan_id);
                
            },
            editDataSync : function(){
                fetch(ADD_URL+'updateDataSync', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renja_program_id : this.Sync.renja_program_id,
                        rkpd_program_id : this.Sync.rkpd_program.rkpd_program_id,
                        program_pembangunan_id : this.Sync.rkpd_program.program_pembangunan_id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },

        //TAMBAHAN
            getSetupRenstra : function(){
                fetch(ADD_URL_SETUP_RENSTRA, {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        tahun : this.form.tahun,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_renja_setup = res_data;

                    if (res_data.length <= 0) {
                        this.form.bidang_urusan_pemerintahan_id = '';
                        this.form.renja_setup_id = '';
                        this.list_data = []
                        this.check_data_add = false;
                        this.getUrusan();
                        this.getBidangFilter();
                    }else{
                        this.form.renja_setup_id = res_data[0].renja_setup_id
                        this.getUrusan();
                        this.getBidangFilter();
                    }
                })
            },
            getUrusan: function(){
                fetch(ADD_URL_URUSAN, {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.form.unit_kerja,
                    })

                }).then(res => res.json()).then((res_data)=>{
                        // console.log(res_data);
                        this.list_urusan = res_data
                        if (res_data.length <= 0) {
                            this.form.urusan_pemerintahan_id = ''
                        }else{
                            this.form.urusan_pemerintahan_id = res_data[0].urusan_pemerintahan_id;
                            this.getBidang();
                        }
                })
            },
            getBidangFilter: function(){
                fetch(ADD_URL_BIDANG+'reqBidangFilterRenstra', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.form.unit_kerja,
                    })

                }).then(res => res.json()).then((res_data)=>{
                    console.log(res_data);
                        this.list_bidang_filter = res_data;
                        if (res_data.length <= 0) {
                            this.form.bidang_urusan_pemerintahan_id = '';
                            
                        } else {
                            this.form.bidang_urusan_pemerintahan_id = res_data[0].bidang_urusan_pemerintahan_id
                            this.getData();
                        }
                })
            },

            getBidang: function(){
                fetch(ADD_URL_BIDANG+'reqRenstra', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        urusan_pemerintahan_id : this.form.urusan_pemerintahan_id,
                        unit_kerja : this.form.unit_kerja,
                    })

                }).then(res => res.json()).then((res_data)=>{
                        // console.log(res_data);
                        this.list_bidang = res_data;
                        if (res_data.length <= 0) {
                            this.form.bidang_urusan_pemerintahan_id = ''
                        }else{
                            this.form.bidang_urusan_pemerintahan_id = res_data[0].bidang_urusan_pemerintahan_id;
                            this.getProgram();
                        }
                })
            },
            getProgram: function(){
                if (this.filter_misi == '') {
                    this.filter_sasaran = '';
                }
                // console.log(this.bidang_urusan_pemerintahan_id);
                fetch(ADD_URL_PROGRAM+'fromRenjaProgram', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id,
                        unit_kerja : this.form.unit_kerja,
                        instansi_id : this.form.instansi_id,
                    })

                }).then(res => res.json()).then((res_data)=>{
                    this.list_data.forEach(list_data => {
                        for (let i = 0; i < res_data.length; i++) {
                            if (list_data.rkpd_program_id == res_data[i].rkpd_program_id) {
                                res_data.splice(i, 1); 
                            }
                        }
                    });
                    // console.log(res_data);
                    this.list_program = res_data;
                })
            },
            getProgramSync: function(){
                if (this.filter_misi == '') {
                    this.filter_sasaran = '';
                }
                // console.log(this.bidang_urusan_pemerintahan_id);
                fetch(ADD_URL_PROGRAM+'fromRenjaProgram', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id,
                        unit_kerja : this.form.unit_kerja,
                        instansi_id : this.form.instansi_id,
                    })

                }).then(res => res.json()).then((res_data)=>{
                    this.list_program_sync = res_data;
                })
            },
            getAnggaranRenstra(data){
                var thn_length = (data.rpjmd_ahir - data.rpjmd_awal);
                var thn_awal = data.rpjmd_awal;
                var list_tahun = [thn_awal];
                var thn_saat_ini = this.form.tahun
                for (let i = 0; i < thn_length; i++) {
                    thn_awal = thn_awal+1
                    list_tahun.push(thn_awal)
                }

                    if (thn_saat_ini == list_tahun[0]) {
                        return this.format_uang(data.tahun_1);
                    } 
                    else if (thn_saat_ini == list_tahun[1]) {
                        return this.format_uang(data.tahun_2);
                    }
                    else if (thn_saat_ini == list_tahun[2]) {
                        return this.format_uang(data.tahun_3);
                    }
                    else if (thn_saat_ini == list_tahun[3]) {
                        return this.format_uang(data.tahun_4);
                    }
                    else if (thn_saat_ini == list_tahun[4]) {
                        return this.format_uang(data.tahun_5);
                    }
                    else if (thn_saat_ini == list_tahun[5]) {
                        return this.format_uang(data.tahun_6);
                    }

            },
            getRenstraProgramIndikator : function(){
                fetch(ADD_URL_RENSTRA_PROGRAM+'readIndikatorFromRenja', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      program_id : this.form.program_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.sasaran.indikator = res_data;

                    if (res_data.length <=0) {
                        this.cek_indikator_array = false;
                    } else {
                        this.cek_indikator_array = true;
                    }


                  console.log(res_data);
                })
            },
            addindikatorSasaran : function(){
                fetch(ADD_URL+'addindikatorSasaranRenjaProgram', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        renja_program_id : this.form.renja_program_id,
                        no : this.sasaran.no,
                        uraian : this.sasaran.uraian,
                        indikator : this.sasaran.indikator,

                    })
                }).then((res_data) => {
                    this.alertku('success', 'Berhasil Menambah Data Sasaran dan Indikator!');
                    this.getSasaran();
                    this.getIndikator();
                })
            },
            getSasaran : function(){
                fetch(ADD_URL+'readIndikatorSasaran', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      renja_program_id : this.form.renja_program_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_sasaran = res_data;
                //   console.log(res_data);
                })
            },
            editSasaran : function(){
                fetch(ADD_URL+'edit_sasaran_program', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify(this.sasaran)
                }).then((res_data) => {
                    this.alertku('success', 'Berhasil Menambah Data Sasaran dan Indikator!');
                    this.getSasaran();
                })
            },
            selectSasaran : function(data){
                this.sasaran.renja_program_sasaran_id = data.renja_program_sasaran_id;
                this.sasaran.no = data.no;
                this.sasaran.uraian = data.uraian;
            },

            removeSasaran : function(data){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'jika "YA" maka Indikator terkait, juga ikut terhapus',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData_sasaran_program", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          renja_program_sasaran_id : data.renja_program_sasaran_id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getSasaran();
                        this.getIndikator();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },


            getIndikator : function(){
                fetch(ADD_URL+'readIndikator', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      renja_program_id : this.form.renja_program_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_indikator = res_data;
                //   console.log(res_data);
                })
            },
            selectIndikator : function(data){
                this.indikator = {
                    renja_program_indikator_id : data.renja_program_indikator_id,
                    no_indikator : data.no_indikator,
                    target : data.target,
                };

            },
            editIndikator : function(){
                fetch(ADD_URL+'edit_indikator_program', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify(this.indikator)
                }).then((res_data) => {
                    this.alertku('success', 'Berhasil Menambah Data Sasaran dan Indikator!');
                    this.getIndikator();
                })
            },
            getRenstraThnIndikator(data){
                console.log(data)
                var thn_length = (data.rpjmd_ahir - data.rpjmd_awal);
                var thn_awal = data.rpjmd_awal;
                var list_tahun = [thn_awal];
                var thn_saat_ini = this.form.tahun
                for (let i = 0; i < thn_length; i++) {
                    thn_awal = thn_awal+1
                    list_tahun.push(thn_awal)
                }

                    // if (thn_saat_ini == list_tahun[0]) {
                    //     return this.format_uang(data.thn_1);
                    // } 
                    // else if (thn_saat_ini == list_tahun[1]) {
                    //     return this.format_uang(data.thn_2);
                    // }
                    // else if (thn_saat_ini == list_tahun[2]) {
                    //     return this.format_uang(data.thn_3);
                    // }
                    // else if (thn_saat_ini == list_tahun[3]) {
                    //     return this.format_uang(data.thn_4);
                    // }
                    // else if (thn_saat_ini == list_tahun[4]) {
                    //     return this.format_uang(data.thn_5);
                    // }
                    // else if (thn_saat_ini == list_tahun[5]) {
                    //     return this.format_uang(data.thn_6);
                    // }

                     if (thn_saat_ini == 2016) {
                        console.log("data sekarang" + list_tahun[0])
                        console.log("adalah" + data.thn_1)
                        return this.format_uang(data.thn_1);
                    } 
                    else if (thn_saat_ini == 2017) {
                        console.log("data sekarang" + list_tahun[1])
                        console.log("adalah" + data.thn_1)
                        return this.format_uang(data.thn_2);
                    }
                    else if (thn_saat_ini == 2018) {
                        console.log("data sekarang" + list_tahun[2])
                        console.log("adalah" + data.thn_1)
                        return this.format_uang(data.thn_3);
                    }
                    else if (thn_saat_ini == 2019) {
                        console.log("data sekarang" + list_tahun[3])
                        console.log("adalah" + data.thn_1)
                        return this.format_uang(data.thn_4);
                    }
                    else if (thn_saat_ini == 2020) {
                        console.log("data sekarang" + list_tahun[4])
                        console.log("adalah" + data.thn_1)
                        return this.format_uang(data.thn_5);
                    }
                    else if (thn_saat_ini == 2021) {
                        console.log("data sekarang" + list_tahun[5])
                        console.log("adalah" + data.thn_1)
                        return this.format_uang(data.thn_6);
                    }

            },
            cek_error_sync : function(data1, data2){
                if (data1 <= 0 || data2 <= 0) {
                    return false
                } else {
                    return true
                }
            },


        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;

                this.instansi_id = obj.instansi_id
                this.form.instansi_id = obj.instansi_id;


                this.getDataTahun();
                // console.log(obj);
            },
            btn_check_data_add : function(){
                if (this.form.renja_setup_id != '') {
                    this.check_data_add = true;
                }
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    this.form.tahun = this.getTgl().tahun;
                    // console.log(res_data);

                    this.getSetupRenstra();
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear(),
                }
            },
            format_uang : function(nilai, prefix){
                var angka = parseFloat(nilai)
                if (angka == null || angka == '' || angka == undefined) {
                    return angka;
                } else {
                    var rupiah = '';		
                    var angkarev = angka.toString().split('').reverse().join('');
                    for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                    return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                }
            },
            parseInteger(tahun){
                return parseInt(tahun)
            },

            routerTO(route){
                $('#m_list_data_indikator').modal('hide');
                $('#m_tambah_data_indikator_kinerja').modal('hide');
                this.$router.push(route);
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
